export const INSIGHTS_PAGE_SLUG = 'insights';
